// F3c-c2 GREEN — PlatformReviewPanel. The inline body of the getting-started
// "platform_approval" accordion, ported from deprecated-business@16fd6b71
// (PlatformReviewPanel). Pure presentation — no network, no React Query.
//
// Precedence (rejected/suspended first, then approval, submitted, ready, blocked):
//   - rejected / suspended → an honest non-success note (NEVER the green "submit
//     it" banner — telling a rejected/suspended operator to submit is wrong, and
//     these terminal-ish statuses must win over every success state). The full
//     rejected experience lives in RejectedPage (the index route); this is the
//     getting-started accordion's honest fallback.
//   - already approved → "Platform review is complete" (done copy).
//   - submitted (status === "in_review") & not yet approved → the distinct
//     "your application is under review, we'll notify you" waiting copy. The
//     operator already submitted, so re-showing "Submit it" would be wrong.
//   - all setup complete & still pending → "submit it so the platform team can
//     review it" (ready copy).
//   - setup NOT complete → "Finish the review items above" (blocked copy).
import { type OrgStatus } from "@/libs/onboardingApi"
import { FormMessage } from "./shared"

export function PlatformReviewPanel({
  status,
  allSetupComplete,
  platformApproved,
}: {
  status: OrgStatus
  allSetupComplete: boolean
  platformApproved: boolean
}) {
  if (status === "rejected") {
    return (
      <FormMessage tone="error">
        This application wasn&apos;t approved. Review the rejection details for the
        next steps.
      </FormMessage>
    )
  }
  if (status === "suspended") {
    return (
      <FormMessage tone="error">
        This organization is suspended. Contact platform support to restore
        access.
      </FormMessage>
    )
  }
  if (platformApproved) {
    return (
      <FormMessage tone="success">
        Platform review is complete. Continue setup in Facility Settings when
        operating details are ready.
      </FormMessage>
    )
  }
  if (status === "in_review") {
    return (
      <FormMessage tone="success">
        Your application is under review — we&apos;ll notify you when it&apos;s
        approved.
      </FormMessage>
    )
  }
  if (allSetupComplete) {
    return (
      <FormMessage tone="success">
        Review package is ready. Submit it so the platform team can review it.
      </FormMessage>
    )
  }
  return (
    <FormMessage tone="error">
      Finish the review items above before platform approval.
    </FormMessage>
  )
}
